import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _set from "lodash/set";
import _cloneDeep from "lodash/cloneDeep";
import _get from "lodash/get";
import _mergeWith from "lodash/mergeWith";
var _excluded = ["children", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useContext } from 'react';
import classnames from 'classnames';
import { BackgroundContext } from "../../context/background.context";
import { BackgroundImage } from "../Image/BackgroundImage/BackgroundImage";
import { BackgroundVideo } from "../Video/BackgroundVideo/BackgroundVideo";
import { Theme } from "./Theme/Theme";
import { Breakpoint } from "../Responsive/Breakpoint/Breakpoint";
import { SourceSet } from "../Responsive/SourceSet/SourceSet";
import { defaultThemeContext } from "../../context/theme.context";
import styles from "./Background.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var backgroundBgColors = ['none', '#FFFFFF',
// White
'#FBF3EB',
// Oat Milk
'#3C34E5',
// Blurple
'#181877',
// Blue Corn
'#380033',
// Eggplant
'#B9B1FA',
// Ube
'#00351C',
// Dino Kale
'#FE8458',
// Papaya
'#D09D67',
// Caramel
'#E0F262',
// Fizzy Apple
'#ACD9F3',
// Ice Blue
'#EBEBFC',
// WW220-10
'#CCD7D2',
// WW320
'#E1F1B2',
// WW320-10
'#FFE6DE',
// WW410
'#F1E2D1',
// WW420
'#F4F5F9' // WW510
];
var defaultClassname = '';
export var defaultBackgroundProps = {
  className: defaultClassname
};
export var Background = function Background(_ref) {
  var _desktop$image$positi, _desktop$image$positi2;
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? defaultClassname : _ref$className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var defaultProps = {
    color: 'none',
    mobile: {
      image: {
        imagePlaceholder: '',
        image1x: '',
        image2x: '',
        image2xHeight: '',
        padding: 'none',
        position: 'top'
      }
    },
    desktop: {
      image: {
        imagePlaceholder: '',
        image1x: '',
        image2x: '',
        position: {
          x: '50%',
          y: '0px'
        }
      }
    },
    alt: '',
    height: 285,
    padding: '',
    theme: defaultThemeContext
  };

  // Merge props with defaultProps.
  // If null, return undefined as null values will override defaults.
  var mergedProps = _mergeWith({}, defaultProps, otherProps, function (a, b) {
    return b === null ? a : undefined;
  });
  var color = mergedProps.color,
    mobile = mergedProps.mobile,
    desktop = mergedProps.desktop,
    video = mergedProps.video,
    height = mergedProps.height,
    padding = mergedProps.padding,
    theme = mergedProps.theme,
    alt = mergedProps.alt;
  var renderBackgroundImage = function renderBackgroundImage(alt, imagePlaceholder, img, img2x, imgPosX, imgPosY) {
    var sizeAuto = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
    var img2xHeight = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
    var gradientImage = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
    if (!img) {
      return false;
    }
    var ariaLabel = !!alt ? alt.trim() : undefined;
    var role = !!ariaLabel ? 'img' : undefined;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [imagePlaceholder && /*#__PURE__*/_jsx(BackgroundImage, {
        uri: imagePlaceholder,
        positionX: imgPosX,
        positionY: imgPosY,
        bgSize: sizeAuto,
        className: className,
        "aria-label": ariaLabel,
        role: role
      }), /*#__PURE__*/_jsxs(SourceSet, {
        children: [/*#__PURE__*/_jsx(BackgroundImage, {
          uri: img,
          positionX: imgPosX,
          positionY: imgPosY,
          bgSize: "".concat(sizeAuto, " ").concat(img2xHeight),
          className: className,
          "aria-label": ariaLabel,
          role: role,
          gradientImage: gradientImage
        }), img2x && /*#__PURE__*/_jsx(BackgroundImage, {
          uri: img2x,
          positionX: imgPosX,
          positionY: imgPosY,
          bgSize: "".concat(sizeAuto, " ").concat(img2xHeight),
          className: className,
          "aria-label": ariaLabel,
          role: role
        })]
      })]
    });
  };
  var renderVideoBackgroundForBreakpoint = function renderVideoBackgroundForBreakpoint(breakpoint, video, color) {
    // Get desktop or mobile video data
    var videoData = _get(video, breakpoint);

    // Strut div ensures that Background fills the specified height.
    // It also provides background-color, if any.
    var videoContainerStyle = {
      height: "".concat(videoData.height, "px")
    };
    var strutStyle = _objectSpread(_objectSpread({}, videoContainerStyle), {}, {
      backgroundColor: color
    });
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.bgStrut,
        style: strutStyle
      }), /*#__PURE__*/_jsx("div", {
        "data-e2e-name": "bg_container_".concat(breakpoint),
        className: classnames(styles.bgFullContainer),
        style: videoContainerStyle,
        children: /*#__PURE__*/_jsx(BackgroundVideo, _objectSpread({}, videoData))
      })]
    });
  };
  var renderVideoBackground = function renderVideoBackground() {
    // Use the background Alt text common to both breakpoints.
    var videoNew = _cloneDeep(video) || {};
    if (alt) {
      _set(videoNew, 'desktop.alt', alt);
      _set(videoNew, 'mobile.alt', alt);
    }
    return /*#__PURE__*/_jsxs(Theme, {
      theme: theme,
      children: [/*#__PURE__*/_jsxs(Breakpoint, {
        breakpoint: "small",
        children: [renderVideoBackgroundForBreakpoint('mobile', videoNew, color), renderVideoBackgroundForBreakpoint('desktop', videoNew, color)]
      }), /*#__PURE__*/_jsx("div", {
        className: classnames(styles.bgFullContainer),
        children: children
      })]
    });
  };
  var backgroundContext = useContext(BackgroundContext);
  var renderVideo = !!_get(video, 'mobile.sources[0].src') || !!_get(video, 'desktop.sources[0].src');
  if (renderVideo) return renderVideoBackground();
  var backgroundMobileClass = '';
  var backgroundMobileBottomClass = '';
  var contextClassName = '';
  if (backgroundContext !== null && backgroundContext !== void 0 && backgroundContext.className) {
    contextClassName = backgroundContext.className;
  }
  var isPadding = mobile.image.padding !== 'none';
  if (isPadding) {
    backgroundMobileClass = styles.bgBackgroundPadding;
    if (mobile.image.padding === 'bottom') {
      backgroundMobileBottomClass = styles.bgBackgroundPaddingBottom;
    }
  }
  var backgroundColorStyle = color !== 'none' ? {
    backgroundColor: color
  } : {};
  return /*#__PURE__*/_jsx(Theme, {
    theme: theme,
    children: /*#__PURE__*/_jsxs("div", {
      style: _objectSpread({
        minHeight: height
      }, backgroundColorStyle),
      className: styles.bgWrapper,
      children: [/*#__PURE__*/_jsxs("div", {
        "data-e2e-name": "bg-container",
        style: {
          paddingBottom: isPadding ? padding : ''
        },
        className: classnames(styles.bgContainer, backgroundMobileClass, backgroundMobileBottomClass, contextClassName),
        children: [color !== 'none' && /*#__PURE__*/_jsx("div", {
          className: styles.bgContainer,
          style: backgroundColorStyle
        }), /*#__PURE__*/_jsxs(Breakpoint, {
          breakpoint: "small",
          children: [mobile.image.image1x && /*#__PURE__*/_jsx("div", {
            className: styles.bgContainer,
            "data-e2e-name": "bg_container_mobile",
            children: renderBackgroundImage(alt, mobile.image.imagePlaceholder, mobile.image.image1x, mobile.image.image2x, '50%', mobile.image.position, mobile.image.bgSize || 'auto', mobile.image.image2xHeight, mobile.image.gradientImage)
          }), desktop.image.image1x && /*#__PURE__*/_jsx("div", {
            className: styles.bgContainer,
            "data-e2e-name": "bg_container",
            children: renderBackgroundImage(alt, desktop.image.imagePlaceholder, desktop.image.image1x, desktop.image.image2x, (_desktop$image$positi = desktop.image.position) !== null && _desktop$image$positi !== void 0 && _desktop$image$positi.x ? desktop.image.position.x : '50%', (_desktop$image$positi2 = desktop.image.position) !== null && _desktop$image$positi2 !== void 0 && _desktop$image$positi2.y ? desktop.image.position.y : '0px', undefined, undefined, desktop.image.gradientImage)
          })]
        })]
      }), children]
    })
  });
};